import useTranslation from '../useTranslation';
import { useEffect } from 'react';

import useAssetParts from 'hooks/useAssetParts';

import type { Props, ServicePartType, UseData } from './types';

const useData = ({ assetId }: Props): UseData => {
    const { NO_PARTS_FOUND, PART_TYPES } = useTranslation();
    const { fetchAssetParts, isLoading, parts } = useAssetParts();

    useEffect(() => {
        fetchAssetParts({ assetId });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [assetId]);

    const partItems = parts.map(({ partType }) => ({
        label: PART_TYPES[partType as ServicePartType] ?? partType,
        value: partType
    }));

    return { isLoading, noItemsText: NO_PARTS_FOUND, partItems };
};

export default useData;
